import React from 'react';
import '../CSS/UtilizationManagement.css';
import utilizationHeroImg from '../Images/services/Utilization Management Services/services-utilization-management-services.png';
import utilizationHeroImgMob from '../Images/Mobile Images/services/Utilization Management Services/service-utilization-management-services-banner-image.png';
import greenTick from '../Images/green-tick-icon.svg';
import utilizationSectionImg from '../Images/services/Utilization Management Services/utilization-management-section-image.png';
import aiServicesUtilizationImgMob from '../Images/Mobile Images/services/Utilization Management Services/ai-services-utilization-management-section-image-mobile.png';
import extensiveExpertiseImgMob from '../Images/Mobile Images/services/Utilization Management Services/extensive-expertise-utilization-management-section-image-mobile.png';
import { Link } from 'react-router-dom';

const UtilizationManagement: React.FC = () => {
  return (
    <>
      <div className="utilization-hero">
        <div
          className="utilization-hero-img"
          style={{ '--hero-bg': `url(${utilizationHeroImg})`, '--hero-bg-mob': `url(${utilizationHeroImgMob})`, backgroundImage: `url(${utilizationHeroImg})` } as React.CSSProperties}
        >
          <div className="utilization-hero-content">
            <div className="utilization-hero-title">Utilization Management Services</div>
            <div className="utilization-hero-main">Lower Denials. Control Costs.</div>
            <div className="utilization-hero-desc">
              Scalable clinical teams—experienced, certified, and cross-trained across specialties—tailored to meet your operational demands.
            </div>
          </div>
        </div>
      </div>
      {/* Utilization Support Facts Section */}
      <div className="utilization_support_facts">
        <div className="usf-left">
          <div className="usf-heading">Your End-to-End Coding Partner</div>
          <div className="usf-desc">From documentation review to claim readiness, we provide full-spectrum coding support throughout the mid-cycle revenue process.</div>
          <Link to="/contact-us" className="usf-contact-btn">Contact Us</Link>
        </div>
        <div className="usf-right">
          <div className="usf-card-grid">
            <div className="usf-card">
              <div className="usf-card-title">Clinical Review</div>
              <div className="usf-card-desc">Reviewing the request for medical necessity and approving the case if it meets the required guidelines</div>
            </div>
            <div className="usf-card">
              <div className="usf-card-title">MD Review Support</div>
              <div className="usf-card-desc">Supporting physician reviewers for faster and more accurate determinations</div>
            </div>
            <div className="usf-card">
              <div className="usf-card-title">Intake</div>
              <div className="usf-card-desc">Receiving the request and creating a case number for clinical review</div>
            </div>
            <div className="usf-card">
              <div className="usf-card-title">Appeals & Grievances</div>
              <div className="usf-card-desc">Reviewing member and provider appeals to assess if the denial was warranted or not</div>
            </div>
            <div className="usf-card usf-card-wide">
              <div className="usf-card-title">Post-Decision Support</div>
              <div className="usf-card-desc">Notifying the requestor of approval or denial via letter or phone</div>
            </div>
          </div>
        </div>
      </div>
      {/* AI Services for Utilization Management Section */}
      <div className="ai-services-utilization-section">
        <div className="ai-services-utilization-section-left">
          <div className="ai-services-utilization-section-title">AI Services for Utilization Management</div>
          <div className="ai-services-utilization-section-subtitle">Analytics & Forecasting</div>
          <div className="ai-services-utilization-section-label">Traditional Process</div>
          <div className="ai-services-utilization-section-desc">Excel-based KPI reports with manual benchmarking</div>
          <div className="ai-services-utilization-section-label" style={{ marginTop: 24 }}>AI Enhancement</div>
          <div className="ai-services-utilization-section-desc">AI dashboards with predictive analytics for cash flow forecasting</div>
          <div className="ai-services-utilization-section-label" style={{ marginTop: 24 }}>Outcomes</div>
          <ul className="ai-services-utilization-section-list">
            <li>Better financial planning</li>
            <li>Faster issue detection</li>
          </ul>
        </div>
        <div className="ai-services-utilization-section-right">
          <picture>
            <source media="(max-width: 1100px)" srcSet={aiServicesUtilizationImgMob} />
            <img src={require('../Images/services/Utilization Management Services/ai-services-utilization-management-section-image.png')} alt="AI Services for Utilization Management Illustration" className="ai-services-utilization-section-img" />
          </picture>
        </div>
      </div>
      {/* Utilization Management List Section */}
      <div className="ultization-management-list">
        <div className="uml-left">
          <img src={utilizationSectionImg} alt="Utilization Management Section" className="uml-img" />
        </div>
        <div className="uml-right">
          <div className="uml-title">Extensive Expertise in Utilization Management</div>
          <ul className="uml-list">
            <li><img src={greenTick} alt="Green Tick" className="uml-tick" /> <span className="uml-list-text"><b>URAC 'Gold Star' Accredited</b><br />Our operations meet the highest standards, with dual accreditations in both <b>HUM and WCUM</b> across all delivery centers.</span></li>
            <li><img src={greenTick} alt="Green Tick" className="uml-tick" /> <span className="uml-list-text"><b>Scalable Clinical Workforce</b><br />Over <b>300 experienced nurses</b> perform Utilization Management services—<b>cross-trained across specialties</b> to meet client demands quickly and efficiently.</span></li>
            <li><img src={greenTick} alt="Green Tick" className="uml-tick" /> <span className="uml-list-text"><b>Training, Quality & Operational Excellence</b><br />Our Utilization Management programs are built and overseen by <b>dedicated subject matter experts</b> to ensure consistent delivery and continuous improvement.</span></li>
            <li><img src={greenTick} alt="Green Tick" className="uml-tick" /> <span className="uml-list-text"><b>Clinical Leadership Oversight</b><br />A <b>staff physician leads our UM program</b>, guiding both clinical decision-making and operational processes.</span></li>
            <li><img src={greenTick} alt="Green Tick" className="uml-tick" /> <span className="uml-list-text"><b>Specialized Role Fulfillment</b><br />We recruit and place highly skilled professionals for niche Utilization Management roles, including:
              <ul className="uml-sublist uml-sublist-hollow">
                <li>Appeals & Grievances Trends Specialists</li>
                <li>CMS Audit Specialists</li>
                <li>Quality of Care Investigators</li>
                <li>Medical Claims Reviewers</li>
                <li>Utilization Support Personnel Technicians (USPTs)</li>
              </ul>
            </span></li>
          </ul>
        </div>
      </div>
      {/* Utilization Management Metrics Section */}
      <div className="ultization-management-metrics">
        <div className="umm-title">
          Quality Isn't Just a Metric—It's a Mission. <b>Medwell360 Delivers Nothing Less.</b>
        </div>
        <div className="umm-metrics-row">
          <div className="umm-metric">
            <div className="umm-metric-value">1.5M+</div>
            <div className="umm-metric-label">Annual Reviews</div>
          </div>
          <div className="umm-metric">
            <div className="umm-metric-value">99%</div>
            <div className="umm-metric-label">Standard Quality Audits</div>
          </div>
          <div className="umm-metric">
            <div className="umm-metric-value">95%</div>
            <div className="umm-metric-label">Clinical Decision Accuracy</div>
          </div>
          <div className="umm-metric">
            <div className="umm-metric-value">300+</div>
            <div className="umm-metric-label">Nurses Specializing in<br />Utilization Management</div>
          </div>
        </div>
      </div>
      {/* Utilization Management Project Framework Section */}
      <div className="ultization-management-framework">
        <div className="umf-title">Robust Project Management Framework</div>
        <div className="umf-stepper-row">
          <div className="umf-step"><div className="umf-circle">1</div></div>
          <div className="umf-line" />
          <div className="umf-step"><div className="umf-circle">2</div></div>
          <div className="umf-line" />
          <div className="umf-step"><div className="umf-circle">3</div></div>
          <div className="umf-line" />
          <div className="umf-step"><div className="umf-circle">4</div></div>
          <div className="umf-line" />
          <div className="umf-step"><div className="umf-circle">5</div></div>
        </div>
        <div className="umf-columns-row">
          <div className="umf-col-wrapper">
            <div className="umf-step-inline"><div className="umf-circle">1</div></div>
            <div className="umf-col">
              <div className="umf-col-title">Intake & Case Initiation</div>
              <ul className="umf-list">
                <li>Multi-channel intake: phone, fax, and web</li>
                <li>Clinical case creation, including patient history and supporting documentation</li>
                <li>Appointment coordination and provider communication</li>
              </ul>
            </div>
          </div>
          <div className="umf-col-wrapper">
            <div className="umf-step-inline"><div className="umf-circle">2</div></div>
            <div className="umf-col">
              <div className="umf-col-title">Case Summarization & Packaging</div>
              <ul className="umf-list">
                <li>Compilation of office visit notes, clinical summaries, and scenarios</li>
                <li>Patient history aggregation and formatting for efficient next-level clinical review</li>
                <li>Peer-to-peer coordination preparation and documentation</li>
              </ul>
            </div>
          </div>
          <div className="umf-col-wrapper">
            <div className="umf-step-inline"><div className="umf-circle">3</div></div>
            <div className="umf-col">
              <div className="umf-col-title">Training</div>
              <ul className="umf-list">
                <li>Evaluation of clinical requests using MCG, InterQual, CMS, or client-specific guidelines</li>
                <li>Collection of additional clinical information to support determinations</li>
                <li>Assessment of medical necessity and appropriateness of services</li>
              </ul>
            </div>
          </div>
          <div className="umf-col-wrapper">
            <div className="umf-step-inline"><div className="umf-circle">4</div></div>
            <div className="umf-col">
              <div className="umf-col-title">Post-Determination Support</div>
              <ul className="umf-list">
                <li>Letter generation and delivery based on determination outcomes</li>
                <li>Outbound phone communication to inform providers and members of decisions</li>
              </ul>
            </div>
          </div>
          <div className="umf-col-wrapper">
            <div className="umf-step-inline"><div className="umf-circle">5</div></div>
            <div className="umf-col">
              <div className="umf-col-title">Quality Assurance</div>
              <ul className="umf-list">
                <li>Full-service support for:
                  <ul className="umf-sublist">
                    <li>Intake and documentation</li>
                    <li>Case summarization</li>
                    <li>Determination and review</li>
                    <li>Post-determination communication</li>
                  </ul>
                </li>
                <li>Handling of:
                  <ul className="umf-sublist">
                    <li>Member and provider appeals</li>
                    <li>Clinical and non-clinical grievances</li>
                  </ul>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default UtilizationManagement;

export {}; 